module.exports = __webpack_public_path__ + "img/new-object-celebration.4e46c18f.png";